import toast from 'react-hot-toast';
import { takeEvery, put, call, select, take } from 'redux-saga/effects';
import * as adminApi from '../../api/adminApi';
import * as actions from './../actions';
import * as selectors from '../selectors';
import { push } from 'connected-react-router';

export function* addEmailTemplate({ payload: { template } }) {
  try {
    yield call(adminApi.addEmailTemplate, template);
    yield put(actions.admin.addEmailTemplateSuccess());
    yield put(actions.admin.getAllTemplates());
    yield put(push('/admin/email-template'));
    toast.success('Te plate added.');
  } catch (e) {
    yield put(actions.admin.addEmailTemplateFail());
    toast.error('An error occurred adding the new template.');
  }
}
export function* updateEmailTemplate({ payload: { template } }) {
  try {
    yield call(adminApi.updateEmailTemplate, template);
    yield put(actions.admin.updateEmailTemplateSuccess());
    yield put(actions.admin.getAllTemplates());
    // yield put(push('/admin/email-template'));
    toast.success('Template updated.');
  } catch (e) {
    yield put(actions.admin.updateEmailTemplateFail());
    toast.error('An error occurred updating the template.');
  }
}
export function* getSites() {
  try {
    const existing = yield select(selectors.getSiteOptionsDetail);
    if (existing && existing.length) {
      take(actions.admin.getSites);
    }

    const sites = yield call(adminApi.getSites);
    yield put(actions.admin.getSitesSuccess(sites));
  } catch (e) {
    yield put(actions.admin.getSitesFail());
    toast.error('An error occurred retrieving the sites.');
  }
}
export function* getAllTemplates() {
  try {
    const templates = yield call(adminApi.getEmailTemplates);

    yield put(actions.admin.getAllTemplatesSuccess(templates));
  } catch (e) {
    yield put(actions.admin.getAllTemplatesFail());
    toast.error('An error occurred retrieving the tempaltes.');
  }
}
export function* getTemplateById({ payload: { id } }) {
  try {
    const template = yield call(adminApi.getEmailTemplateById, id);
    yield put(actions.admin.getTemplateByIdSuccess(template));
  } catch (e) {
    yield put(actions.admin.getTemplateByIdFail());
    toast.error('An error occurred retrieving the email template.');
  }
}

export function* adminSagas() {
  yield takeEvery(actions.admin.getAllTemplates, getAllTemplates);
  yield takeEvery(actions.admin.getTemplateById, getTemplateById);
  yield takeEvery(actions.admin.updateEmailTemplate, updateEmailTemplate);
  yield takeEvery(actions.admin.addEmailTemplate, addEmailTemplate);
  yield takeEvery(actions.admin.getSites, getSites);
}
